import { Card } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import type { Draft } from '@/types/api';
import { DraftItem } from './DraftItem';

export interface DraftsProps {
  drafts?: Draft[] | null;
  assignmentId: string;
}

export const Drafts = ({ drafts, assignmentId }: DraftsProps) => {
  if (!drafts || drafts.length === 0) {
    return null;
  }

  return (
    <Card className='mt-6 gap-0'>
      <ScrollArea className='overflow-hidden'>
        <div className='p-4 space-y-3'>
          {drafts.map((draft, index) => {
            const key = draft.id || `draft-${index}`;

            return (
              <DraftItem
                key={key}
                draft={draft}
                index={index}
                assignmentId={assignmentId}
              />
            );
          })}
        </div>
      </ScrollArea>
    </Card>
  );
};
